import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, lovLabel, FormProps, ClosedContentProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {PrimaryKeyString} from 'core/form/rules';
import {DocumentType} from "core/document/documentDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";



const definition: DefinitionType = {
  formName: 'DocumentTypeForm',
  fields: [{
    name: 'documentTypeId',
    validators: ['IsRequired']
  }, {
    name: 'documentName',
    validators: ['IsRequired']
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'type',
    validators: ['IsRequired']
  }, {
    name: 'format'
  }, {
    name: 'templateType'
  }, {
    name: 'location'
  }, {
    name: 'cardinality'
  }, {
    name: 'langSource'
  }, {
    name: 'dataPrepareBean'
  }]
};

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedContentProps<DocumentType>) => (
  <div style={{display: 'flex', flexDirection: 'column'}}>

    <h5 style={{marginTop: 0, fontSize: '18px', fontWeight: 'bold'}}> <span className="zz-grey-text">{lovLabel(dataObject.type)}</span> {dataObject.documentName}</h5>

    <div className="form-text-row">
      <FieldText label={fields.location.textLabel} value={dataObject.location}/>
      <FieldText label={fields.templateType.textLabel} value={dataObject.templateType}/>
      <FieldText label={fields.format.textLabel} value={dataObject.format}/>
      <FieldText label={fields.cardinality.textLabel} value={dataObject.cardinality}/>
      <FieldText label={fields.langSource.textLabel} value={dataObject.langSource}/>
      <FieldText label={fields.documentTypeId.textLabel} value={dataObject.documentTypeId}/>

    </div>

    <div className="form-text-row">
      <FieldText label={fields.comment.textLabel} value={dataObject.comment}/>
    </div>

  </div>
);

@createForm(definition, ClosedContent)
@observer
export default class DocumentTypeForm extends React.Component<FormProps<DocumentType, DocumentType>, undefined> {

  render() {


    let {dataObject, rootObject, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {documentTypeId, documentName, comment, type, format, templateType, cardinality, langSource, location} = fields;

    let openContent = (
      <div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <MdTextField {...documentTypeId.props} disabled={!dataObject.$new} />
            <Validate field={documentTypeId} value={documentTypeId.props.value}>
              <PrimaryKeyString/>
            </Validate>
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...documentName.props} />
            <Validate field={documentName} value={documentName.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-2">
            <StyledSelect {...type.props} />
            <Validate field={type} value={type.props.value}/>
          </div>
        </div>


        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...templateType.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...format.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...cardinality.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...langSource.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...location.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );



    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}







// WEBPACK FOOTER //
// ./src/core/document/component/documentTypeForm.tsx